import React from "react";

const Login = () => {
  return (
    <div data-netlify-identity-button></div>
  )
};

export default Login;
